var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.interfaceProgresses),function(progress){return [(_vm.value === progress.value)?_c('VChip',{key:progress.value,attrs:{"color":progress.color,"label":"","small":""}},[_vm._v(" "+_vm._s(progress.name)+" ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }